import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import { Typography } from '@mui/material';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import CustomSelect from "../CustomComponents/CustomSelect";
import { Link } from "react-router-dom";
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import { logger, checkAuthentication } from '../../utils';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';

export default function EditUserDialog({ handleEditCallback, data }) {
    //	console.log("Data in EditUserDialog", data);
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [leadChoices, setLeadChoices] = React.useState([])
    const [roleChoices, setRoleChoices] = React.useState([])
    const [appRoleChoices, setAppRoleChoices] = React.useState([])
    const [PropType, setPropType] = React.useState([])
    const [UserItemChoices, setUserItemChoices] = React.useState([]);
    const [costCenterChoices, setCostCenterChoices] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const timer = React.useRef(null);
    const [loadData, setLoadData] = React.useState(true);
    

    const initialValues = {
        firstName: data.FirstName,
        lastName: data.LastName,
        BYSEmail: data.Email,
        password: "",
        CostCenterID: data.CostCenterID,
        lead: data.AssignedTo,
        appRole: data.AppRoleID,
        defaultRole: data.DefaultRoleID,
        IsActive: data.IsActive ? true : false,
        PayRate: data.PayRate,
        propList: PropType
    };

    const validFormSchema = Yup.object({
        firstName: Yup.string('Please enter a first name').required('First name is required'),
        lastName: Yup.string('Please enter a last name').required('Last name is required'),
        BYSEmail: Yup.string().test(
		'Please enter a BYS Email',
        'Please enter a valid email - xxxxx@us.beyondsoft.com',
        value => (value).match(/^^\w+([\.-]?\w+)*@us.beyondsoft.com$$/)),
        CostCenterID: Yup.string('Please enter the Cost Center.').required('Cost Center is required'), CostCenterID: Yup.string('Please enter the Cost Center.').required('Cost Center is required'),
        lead: Yup.string('Please enter a lead/approver for this user'),
        appRole: Yup.string('Please enter a appRole for this user'),
        defaultRole: Yup.string('Please enter a Default Role for this user'),
        password: Yup.string('Please enter a password').min(8, 'Password must be at least 8 characters').oneOf([Yup.ref('confirmPassword'), null], 'Passwords must match'),
        confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
        PayRate: Yup.string('Please enter a PayRate for this user'),
        IsActive: Yup
            .boolean(),
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            firstName: values.firstName,
            lastName: values.lastName,
            Email: values.BYSEmail,
            Password: values.password,
            CostCenterID: values.CostCenterID,
            AssignedTo: values.lead,
            AppRoleID: values.appRole,
            DefaultRole: values.defaultRole,
            IsActive: values.IsActive,
            PropList: values.propList,
            PayRate: values.PayRate,
        };

        handleEditCallback(msg);

        handleClose();
        loadProp()
    })

    const handleClickOpen = () => {
		setIsLoading(true);
        setRefresh(true)
        setOpen(true);
        setLoadData(true);
    };

    const handleClose = () => {
        setOpen(false);
        setPropType([]);
        setAppRoleChoices([]);
        setRoleChoices([]);
        setLeadChoices([]);
        setLoadData(false);
    };

    async function loadLead() {
        try {
            const response = await fetch('/api/User/dropdown/Assigned', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setLead(json))
        } catch (error) {
            console.error(`EditUser Error loading Lead`, error)
        }
    }

    async function loadAppRole() {
        try {
            const response = await fetch('/api/AppRole/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setAppRole(json));
        } catch (error) {
            console.error(`EditUser Error loading AppRole`, error)
        }
    }

    async function loadRole() {
        try {
            const response = await fetch(`/api/userRole/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setRole(json));
        } catch (error) {
            console.error(`EditUser Error loading Role`, error)
        }
    }

    async function loadProp() {
        try {
            const response = await fetch(`/api/UserPropType/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProp(json));
        } catch (error) {
            console.error(`EditUser Error loading PropData`, error)
        }

    }

    async function loadUserItem() {
        try {
            const response = await fetch('api/user_prop_item', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setUserItem(json) });
        } catch (error) {
            console.error(`EditUser Error loading PropItemLists`, error)
        }
    }

    async function loadCostCenterItem() {
        try {
            const response = await fetch('/api/cost_center/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setCostCenterItem(json) });
        } catch (error) {
            console.error(`EditUser Error loading CostCenter`, error)
        }
    }
    const setLead = (json) => {
        let choices = [{ label: "No Lead", value: 0 }];
        json.forEach(choice => choices.push({ label: choice.FirstName + " " + choice.LastName, value: choice.ID }))
        setLeadChoices(choices)
    }
    const setAppRole = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.AppRoleName, value: choice.ID }))
        setAppRoleChoices(choices)
    }

	const setRole = (json) => {
		let choices = [{ label: "No Default", value: 0 }];
		json.forEach(choice => choices.push({
			label: <div style={choice.RoleStatus===0 || choice.PositionStatus===0 || (moment(choice.RoleEndDate).isSameOrBefore(moment(new Date()))) ? { color: "red" } : {}}>
	                            {choice.Lab + " / " + choice.Position}
	                        </div>,
			value: choice.ID,
			disabled: choice.RoleStatus===0 || choice.PositionStatus===0 || (moment(choice.RoleEndDate).isSameOrBefore(moment(new Date())))
		}))
		setRoleChoices(choices)
	}

    const setProp = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ ID: choice.ID, label: choice.Name, IsDropdown: choice.IsDropdown, value: choice.IsDropdown ? choice.ItemID : choice.Data , validation: choice.Validation, defaultformat: choice.DefaultFormat }))
        setPropType(choices)
    }

    const setUserItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TypeID: choice.TypeID }))
        setUserItemChoices(choices)
    }

    const setCostCenterItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setCostCenterChoices(choices)
    }
    async function processData(data) {
        try {
            const processProp = await loadProp()
            const processCC = await loadCostCenterItem()
            const processUItem = await loadUserItem()
            const processLead = await loadLead()
            const processAppRole = await loadAppRole()
            const processRole = await loadRole()



            logger(`await props`, PropType)
            /*   logger(`CostCenter`, CostCenter)
               logger(`task choices`, TaskChoices)
               logger(`User Choices `, UserChoices)
               logger(`Role Choices `, RoleChoices)
               logger(`Task Item Choices `, taskItemChoices)*/

        } catch (error) {
            console.error(`Error loading EditUser Data ${data.ID}`, error)
        }
        if (PropType.length > 0) {
            setRefresh(false)
            setIsLoading(false)
            setLoadData(false)
            logger(`check PropTypeLen - `, PropType)
        } else {
            logger(`check PropTypeLen Else- `, PropType)
            timer.current = setTimeout(() => {
                setLoadData(true)
                setRefresh(true)

                logger(`end of else - data `, loadData)
                logger(`end of else - refresh `, refresh)
            }, 800);

        }

    }
    React.useEffect(() => {
        if (refresh) {
            /* logger('in refresh')
             loadLead()
                 .then(loadAppRole())
                 .then(loadProp())
                 .then(loadUserItem())
                 .then(loadCostCenterItem())
                 .then(loadRole())
 
                 setRefresh(false);*/
            if (open) {
				checkAuthentication();
                if (loadData) {
                    processData()
                }

                logger(`end of loadData`, initialValues)
                setLoadData(false)
            }

        }
    })
    // enableReinitialize
    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit User" placement="top-end">
                <IconButton color="default" onClick={handleClickOpen}>
                    <AccountBoxIcon />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">

                <DialogContent>
                    {(isLoading) &&

                        <FormControl sx={{ m: 1, height: 200, width: 300 }}>
                            <InputLabel htmlFor="outlined-Name">Loading User Data</InputLabel>
                            <Box sx={{
                                display: 'flex',
                                minHeight: 200,
                                width: '100%',

                                m: 1,

                                alignContent: 'center'
                            }}>
                                <Fade
                                    in={(isLoading)}
                                    style={{
                                        transitionDelay: !isLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                        <CircularProgress color="secondary" />
                                        <CircularProgress color="success" />
                                        <CircularProgress color="inherit" />
                                    </Stack>
                                </Fade>
                            </Box>
                        </FormControl>
                    }
                    {(!isLoading) &&
                        <Formik
                            initialValues={initialValues}

                            validationSchema={validFormSchema}
                            onSubmit={(values, { resetForm }) => {
                                onTrigger(values);
                                resetForm();
                            }}
                        >
                            {props => (
                                <Form className='FormProfileCreate' style={{ maxHeight: '80%' }} onSubmit={onTrigger}>
                                    <AppBar sx={{ position: 'relative' }}>
                                        <Toolbar>
                                            <IconButton
                                                edge="start"
                                                color="inherit"
                                                onClick={handleClose}
                                              
                                                aria-label="close"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                                User
                                            </Typography>
                                            <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                                save
                                            </Button>
                                        </Toolbar>
                                    </AppBar>
                                    <div>
                                        <DialogTitle>Edit User</DialogTitle>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name="firstName"
                                                id="outlined-firstname"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.firstName}
                                                error={props.touched.firstName && Boolean(props.errors.firstName)}
                                                helperText={props.touched.firstName && props.errors.firstName}
                                                label="First Name"
                                            />
                                        </FormControl>

                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                required
                                                name="lastName"
                                                id="outlined-lastname"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.lastName}
                                                error={props.touched.lastName && Boolean(props.errors.lastName)}
                                                helperText={props.touched.lastName && props.errors.lastName}
                                                label="Last Name"
                                            />

                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 260 }}>
                                            <TextField
                                                required
                                                name="BYSEmail"
                                                id="outlined-BYSEmail"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.BYSEmail}
                                                error={props.touched.BYSEmail && Boolean(props.errors.BYSEmail)}
                                                helperText={props.touched.BYSEmail && props.errors.BYSEmail}
                                                label="BYSEmail"
                                            />
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                type="Password"
                                                name="password"
                                                id="outlined-Password"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.password}
                                                error={props.touched.password && Boolean(props.errors.password)}
                                                helperText={props.touched.password && props.errors.password}
                                                label="Password"
                                            />
                                        </FormControl>

                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                type="Password"
                                                name="confirmPassword"
                                                id="outlined-confirmPassword"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.confirmPassword}
                                                error={props.touched.confirmPassword && Boolean(props.errors.confirmPassword)}
                                                helperText={props.touched.confirmPassword && props.errors.confirmPassword}
                                                label="Confirm Password"
                                            />
                                        </FormControl>

                                    </div>
                                    <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <InputLabel htmlFor="outlined-Name">Lead/Verifier</InputLabel>
                                            <CustomSelect
                                                name="lead"
                                                id="outlined-lead"
                                                options={leadChoices}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.lead}
                                                error={props.touched.lead && Boolean(props.errors.lead)}
                                                helperText={props.touched.lead && props.errors.lead}
                                                label="Lead/Verifier"
                                            >
                                            </CustomSelect>
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <InputLabel htmlFor="outlined-App Role">App Role</InputLabel>
                                            <CustomSelect
                                                name="appRole"
                                                id="outlined-AppRole"
                                                options={appRoleChoices}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.appRole}
                                                error={props.touched.appRole && Boolean(props.errors.appRole)}
                                                helperText={props.touched.appRole && props.errors.appRole}
                                                label="App Role"
                                            >
                                            </CustomSelect>
                                        </FormControl>

                                        <div>
                                            <FormControl sx={{ m: 1, width: 220 }}>
                                                <InputLabel htmlFor="outlined-CostCenterName">Cost Center Name</InputLabel>
                                                <CustomSelect
                                                    name="CostCenterID"
                                                    id="outlined-CostCenterID"
                                                    options={costCenterChoices}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.CostCenterID}
                                                    error={props.touched.CostCenterID && Boolean(props.errors.CostCenterID)}
                                                    helperText={props.touched.CostCenterID && props.errors.CostCenterID}
                                                    label="CostCenterID"
                                                >
                                                </CustomSelect>
                                            </FormControl>

                                            <FormControl sx={{ m: 1, width: 220 }}>
                                                <TextField
                                                    name="PayRate"
                                                    id="outlined-PayRate"
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.PayRate}
                                                    error={props.touched.PayRate && Boolean(props.errors.PayRate)}
                                                    helperText={props.touched.PayRate && props.errors.PayRate}
                                                    label="Pay Rate"
                                                />
                                            </FormControl>
                                        </div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <InputLabel htmlFor="outlined-defaultRole">Default Role</InputLabel>
                                            <CustomSelect
                                                name="defaultRole"
                                                id="outlined-defaultRole"
                                                options={roleChoices}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.defaultRole}
                                                error={props.touched.lead && Boolean(props.errors.lead)}
                                                helperText={props.touched.lead && props.errors.lead}
                                                label="DefaultRole"
                                            >
                                            </CustomSelect>
                                        </FormControl>
                                    </div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>


                                    < FormControl>
                                        <FieldArray name="propList">
                                            <div>
                                                {props.values.propList.map((p, index) => {
                                                    const PropItem = `propList[${index}].value`;
                                                    const touchedPropItem = getIn(props.touched, PropItem);
                                                    const errorPropItem = getIn(props.errors, PropItem);

                                                    if (p.IsDropdown == 1) {
                                                        return (
                                                            //<div key={index}>
                                                            <FormControl sx={{ m: 1, width: 235, margin: 0 }}>
                                                                <InputLabel htmlFor="outlined-p.label" id={p.label + index} sx={{ paddingTop: 1.3, paddingLeft: 1.3 }}>
                                                                    {p.label}
                                                                </InputLabel>
                                                                <Select

                                                                    name={PropItem}
                                                                    size="large"
                                                                    sx={{ m: 1 }}
                                                                    style={{ textAlign: 'center' }}
                                                                    labelId={p.label}
                                                                    id={index}
                                                                    value={p.value}
                                                                    label={p.label}
                                                                    onChange={props.handleChange}

                                                                >
                                                                    {UserItemChoices.map((Choice, i) => {
                                                                        if (p.ID === Choice.TypeID) {
                                                                            return (
                                                                                <MenuItem key={i} value={Choice.value}>{Choice.label}</MenuItem>
                                                                            );
                                                                        }
                                                                    })}
                                                                </Select>
                                                            </FormControl>
                                                            // </div>
                                                        );
                                                    } else {
                                                        return (
                                                            // <div key={index}>

                                                            <FormControl sx={{ m: 1, width: 220 }}>
                                                                <TextField
                                                                    name={PropItem}
                                                                    id={index}
                                                                    value={p.value}
                                                                    onChange={props.handleChange}
                                                                    onBlur={props.handleBlur}
                                                                    error={p.value && p.value!=="" && !p.value.match(p.validation)}
                                                               		helperText={p.value && p.value!=="" && !p.value.match(p.validation) && "Please select a valid "+p.label + " "+ p.defaultformat}
                                                                    label={p.label}
                                                                />
                                                            </FormControl>
                                                            // </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        </FieldArray></FormControl>

                                </Form>
                            )}
                        </Formik>
                    }
                </DialogContent>

            </Dialog>
        </MuiThemeProvider>
        </div>
    );
}